/* import __COLOCATED_TEMPLATE__ from './global-trial-banner-dropdown-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();